import React from "react";

import LogsList from "../features/reports/LogsList";
import RobotNavigation from "../features/robot/RobotNavigation";

function NovDataLogsPage() {
  return (
    <>
      <RobotNavigation />
      <LogsList />
    </>
  );
}

export default NovDataLogsPage;
